import React from 'react';
import styles from './TabBar.module.css';

export interface Tab {
    key: string;
    label: string;
}

interface TabBarProps {
    tabs: Tab[];
    activeKey: string;
    onChange: (key: string) => void;
}

const TabBar: React.FC<TabBarProps> = ({tabs, activeKey, onChange}) => (
    <div className={styles.tabBar}>
        {tabs.map(tab => (
            <button
                key={tab.key}
                className={`${styles.tab} ${activeKey === tab.key ? styles.tabActive : ''}`}
                onClick={() => onChange(tab.key)}
            >
                {tab.label}
            </button>
        ))}
    </div>
);

export default TabBar;